<template>
  <v-dialog
    :value="true"
    max-width="1000"
    @input="close"
  >
    <v-card>
      <v-card-title>{{ documentKind === 'invoice' ? 'Fatura / Makbuz' : documentKind === 'company' ? 'Şirket Belgesi' : '20/B İstisna Belgesi' }}</v-card-title>
      <v-card-text>
        <div
          v-if="loading"
          class="text-center pa-8"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <p class="mt-3">
            Belge yükleniyor…
          </p>
        </div>
        <v-alert
          v-else-if="error"
          type="error"
          outlined
        >
          {{ error }}
          <v-btn
            text
            @click="load"
          >
            Tekrar kontrol et
          </v-btn>
        </v-alert>
        <template v-else-if="url">
          <pdf-document-canvas
            v-if="mimeType === 'application/pdf'"
            :url="url"
          ></pdf-document-canvas>
          <img
            v-else
            :src="url"
            alt="Yüklenen belge"
            class="tax-document-image"
          >
          <a
            :href="url"
            target="_blank"
            rel="noopener noreferrer"
          >Yeni sekmede görüntüle</a>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="close"
        >
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import PdfDocumentCanvas from './PdfDocumentCanvas.vue'
import { resolveApiErrorMessage } from '@/utils/apiErrors'

const PREVIEW_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp']

export default {
  components: { PdfDocumentCanvas },
  props: {
    documentId: { type: [Number, String], required: true },
    headers: { type: Object, required: true },
    documentKind: { type: String, default: 'tax', validator: value => ['tax', 'invoice', 'company'].includes(value) },
  },
  data: () => ({
    loading: true, error: '', url: '', mimeType: '', disposed: false, requestStarted: false,
  }),
  created() {
    this.load()
  },
  beforeDestroy() {
    this.dispose()
  },
  methods: {
    async load() {
      if (this.disposed || (this.loading && this.requestStarted)) return
      this.requestStarted = true
      this.loading = true
      this.error = ''
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_API_URL}admin/${this.documentKind === 'invoice' ? 'withdrawal-documents' : this.documentKind === 'company' ? 'company-documents' : 'digital-business-documents'}/${this.documentId}/content`,
          { headers: this.headers, responseType: 'blob' },
        )
        if (this.disposed) return
        const mimeType = String(response.data.type || '').split(';')[0].trim().toLowerCase()
        if (!PREVIEW_TYPES.includes(mimeType)) {
          this.error = 'Bu dosya türü görüntülenemiyor. PDF, JPG, PNG veya WEBP gereklidir.'

          return
        }
        this.mimeType = mimeType
        this.url = URL.createObjectURL(response.data)
      } catch (error) {
        let message = resolveApiErrorMessage(error, 'Belge görüntülenemedi.')
        const data = error.response?.data
        const raw = typeof data?.text === 'function' ? await data.text() : JSON.stringify(data || '')
        if (raw.includes('DOCUMENT_SCAN_PENDING')) message = 'Belgenin güvenlik taraması sürüyor. Biraz sonra tekrar kontrol edin.'
        else if (raw.includes('DOCUMENT_SCAN_THREAT_FOUND')) message = 'Belgede güvenlik tehdidi tespit edildi. Dosya görüntülenemez veya onaylanamaz.'
        else if (raw.includes('DOCUMENT_SCAN_UNAVAILABLE')) message = 'Güvenlik taraması tamamlanamadı. Belge şu an kullanılamıyor.'
        else if (raw.includes('LEGACY_INVOICE_SCAN_REQUIRED')) message = 'Bu eski belgenin güvenlik taramasına alınması gerekiyor.'
        if (!this.disposed) this.error = message
      } finally {
        if (!this.disposed) this.loading = false
      }
    },
    dispose() {
      this.disposed = true
      if (this.url) URL.revokeObjectURL(this.url)
      this.url = ''
    },
    close() {
      this.dispose()
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.tax-document-image { display: block; max-width: 100%; max-height: 65vh; margin: 0 auto 16px; object-fit: contain; }
</style>
